module.exports = __webpack_public_path__ + "static/media/logo.a19276d8.png";